import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd';
import {
    required,
} from "../validDesc";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS10 = props => {
    const ans = '不良習慣'
    const select_arr = [
        {
            value: '1',
            label: '無'
        },
        {
            value: '2',
            label: '發怪聲'
        },
        {
            value: '3',
            label: '作弄他人'
        },
        {
            value: '4',
            label: '吃指頭'
        },

        {
            value: '5',
            label: '咬筆'
        },
        {
            value: '6',
            label: '沉迷不良書刊'
        },
        {
            value: '7',
            label: '沉迷電動玩具'
        },
        {
            value: '8',
            label: '上課吃東西'
        },
        {
            value: '9',
            label: '說謊'
        },
        {
            value: '10',
            label: '吸煙'
        },
        {
            value: '11',
            label: '吸毒'
        }

    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s10"
                   type="checkbox"/>
        </div>
    )
}

export default SseS10


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS10.jsx